import close from '../../../assets/images/close.svg'
import featured from "../../../assets/images/featured.svg";

const AddBrand = ({ showAddBrandPopup, popupRef, errorMessage, formData, handleChange, setShowAddBrandPopup, handleSubmit, handleImageUpload, isLoading, error, setFormData, isSlugChanged, setIsSlugChanged }) => {

    function convertToSlug(str) {
        let slug = str.toLowerCase();

        slug = slug.trim();

        slug = slug.replace(/[^a-z0-9\s-]/g, '');

        slug = slug.replace(/\s+/g, '-');

        return slug;
    }

    const handleNameChange = (e) => {
        const { value } = e.target;
        handleChange(e);
        if (!isSlugChanged) {
            const slug = convertToSlug(value);
            handleChange({ target: { name: 'slug', value: slug } });
        }
    };

    const handleSlugChange = (e) => {
        handleChange(e);
        setIsSlugChanged(true)
        if (e.target.value === '') {
            setIsSlugChanged(false)
        }
    };

    return (
        <>
            {showAddBrandPopup && (
                <>
                    <div className="popup-overlay"></div>
                    <div className="popup-box add-new-user add-category-popup" ref={popupRef}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowAddBrandPopup(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>{formData?.brandId ? 'Edit Brand' : 'Add New Brand'}</div>
                        <div className="popup-form">
                            <div className="form-group">
                                <label>Image</label>

                                <div className={`imageUploadBox`}>
                                    <div id="newpageImageUpload" onClick={(e) => { handleImageUpload(e) }} >
                                        <div className='image-upload-content'>
                                            <img src={featured} alt="FeaturedImage" />
                                            <p >
                                                <span>Upload</span> <span>Media </span>
                                                <br />
                                                JPG, PNG (max. 128MB)
                                            </p>
                                        </div>
                                    </div>
                                    {/* <input type="file" id="brand-img" accept="image/*" hidden onChange={handleImageUpload} /> */}
                                </div>
                                {formData?.image && (
                                    <div className="image-preview">
                                        <img
                                            src={formData?.image?.url || ''}
                                            alt={formData?.image?.name || 'Featured Image'}
                                            className="preview-img"
                                        />
                                    </div>
                                )}

                                {errorMessage?.image && (
                                    <p className="error-message">{errorMessage?.image}</p>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Brand Name</label>
                                <input
                                    className='form-input'
                                    name='name'
                                    value={formData?.name}
                                    onChange={handleNameChange}
                                    type='text'
                                    placeholder="Enter brand name"
                                />
                                {errorMessage?.name && <p className='error-message'>{errorMessage?.name}</p>}
                            </div>

                            <div className="form-group">
                                <label>Slug</label>
                                <input
                                    className='form-input'
                                    name='slug'
                                    value={formData?.slug}
                                    onChange={handleSlugChange}
                                    type='text'
                                    placeholder="Enter slug"
                                    onBlur={(e) => {
                                        let urlValue = convertToSlug(e.target.value);
                                        setFormData({ ...formData, slug: urlValue });
                                        if (e.target.value === '') {
                                            if (!isSlugChanged) {
                                                let urlValue = convertToSlug(formData?.name);
                                                setFormData({ ...formData, slug: urlValue });
                                            }
                                        }
                                    }}
                                />
                                {errorMessage?.slug && <p className='error-message'>{errorMessage?.slug}</p>}
                            </div>

                            <div className="form-group form-checkbox">
                                <input
                                 id='isPopular'
                                 type='checkbox'
                                 name='isPopular'
                                 checked={formData?.isPopular}
                                 onChange={(e) => {
                                    setFormData({ ...formData, isPopular: e.target.checked });
                                 }}
                                />
                                <label htmlFor='isPopular'>Set as popular brand</label>
                            </div>

                            <div className="form-group">
                                <label>SEO Title</label>
                                <input
                                    className='form-input'
                                    name='seoTitle'
                                    value={formData?.seoTitle}
                                    onChange={handleChange}
                                    type='text'
                                    placeholder="Enter SEO Title"
                                />
                            </div>
                            <div className="form-group">
                                <label>SEO content</label>
                                <textarea
                                    className='form-input description'
                                    name='seoContent'
                                    value={formData?.seoContent}
                                    onChange={handleChange}
                                    placeholder="Enter SEO Content"
                                    rows="5"
                                />
                                {errorMessage?.description && <p className='error-message'>{errorMessage?.description}</p>}
                            </div>
                            <div className="form-group">
                                <label>Keyword</label>
                                <input
                                    className='form-input'
                                    name='keyword'
                                    value={formData?.keyword}
                                    onChange={handleChange}
                                    type='text'
                                    placeholder="Enter Keyword"
                                />
                            </div>
                            {error !== "" && error && <p className='error-message'>{error}</p>}
                            <div className="popup-actions">
                                <button className="cancel-btn" onClick={() => setShowAddBrandPopup(false)}>Cancel</button>
                                <button className="save-btn" onClick={handleSubmit}>
                                    {isLoading ?
                                        <div className={`ringLoader loaderContinue`}></div>
                                        :
                                        'Save'
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default AddBrand
